const initialvalues = {

    backFlag1logintapout: "fresh",
    formikValueslogintapout: {},
    paymentlogintapout: "",
    setOwnerDetailsbyRadiologintapout: [],
    setfilterOwnerDetailsbyRadiologintapout: [],

    setDueDetailslogintapout: [],
    bakFlaglogintapout: false,
}


export default function OutsideTapFeeReducer(details = initialvalues, action) {


    switch (action.type) {
        case "OUTTAPPAYMENTLOGIN":
            return {
                ...details,
                paymentlogintapout: action.payload
            };

        case "OUTTAPSETOWNERDETAILSBYRADIOLOGIN":
            return {
                ...details,
                setOwnerDetailsbyRadiologintapout: action.payload
            };
        case "OUTTAPSETFILTEROWNERDETAILSBYRADIOLOGIN":
            return {
                ...details,
                setfilterOwnerDetailsbyRadiologintapout: action.payload
            };
        case "OUTTAPSETDUEDETAILSLOGIN":
            return {
                ...details,
                setDueDetailslogintapout: action.payload
            };

        case "OUTTAPFORMIKVALUESLOGIN":
            return {
                ...details,
                formikValueslogintapout: action.payload
            };
        case "OUTTAPBACKFLAGLOGIN":
            return {
                ...details,
                bakFlaglogintapout: action.payload
            };
        case "OUTTAPBACKFLAG1LOGIN":
            return {
                ...details,
                backFlag1logintapout: action.payload
            };


        default: return details;
    }
}